import { useQuery } from '@tanstack/react-query';
import { getAuditEntries } from '@/api/misc';
import LoadingTimeline from '@/components/UI/loading/LoadingTimeline';

type HistoryTimelineProps = {
  activity?: any;
  resourceType: string;
  title?: string;
  showApplicationReceived?: boolean;
};

export default function HistoryTimeline({ activity, resourceType, title }: HistoryTimelineProps) {
  //Uplift: useQuery v5
  const fetchAuditEntries = useQuery({
    queryKey: [`${resourceType}-audit`, activity?.id],
    queryFn: () =>
      getAuditEntries({
        params: {
          resource_type: resourceType,
          resource_id: activity?.id,
        },
      }),
  });

  const activities = fetchAuditEntries?.data?.data || [];

  const insertComponentsIntoText = (
    str: string,
    replacements: {
      [key: string]: React.ReactNode;
    }
  ) => {
    const splitRegex = new RegExp(/\{(\w*)\}/g);
    const parts = str.split(splitRegex);
    return parts.map((part) => {
      if (Object.hasOwn(replacements, part)) {
        return replacements[part];
      }
      return part;
    });
  };
  return (
    <div className='flex flex-col max-h-full bg-white shadow sm:rounded-lg divide-y'>
      <div className='py-4'>
        <h3 id='timeline-title' className='font-bold px-6 py-3 m-0 border-l-4 border-primaryColor-normal'>
          {title ?? 'Timeline'}
        </h3>
      </div>
      <div className='p-6 overflow-y-auto'>
        {fetchAuditEntries.isLoading && <LoadingTimeline />}
        {!fetchAuditEntries.isLoading && (
          <dl className='space-y-5 h-screen/2 pb-5'>
            {activities?.map((activity, index) => (
              <>
                <div key={activity.id} className='relative'>
                  {index + 1 < activities.length && (
                    <dt>
                      <span className='absolute left-1.5 top-4 h-full w-0.5 bg-gray-200' aria-hidden='true' />
                    </dt>
                  )}
                  <dd className='flex gap-4'>
                    <div>
                      <span className='p-1.5 rounded-full flex items-center justify-center bg-tertiaryColor-light'></span>
                    </div>
                    <div className='text-sm whitespace-wrap'>
                      <p>
                        {insertComponentsIntoText(activity?.description, {
                          user: <strong>{activity.user.name}</strong>,
                          newAssignedUser: <strong>{activity.meta?.newAssignedUser?.name}</strong>,
                        })}
                      </p>
                      <time dateTime={activity?.createdAt} className='text-xs text-neutralColor-normal'>
                        {new Date(activity?.createdAt).toDateString()}
                      </time>
                    </div>
                  </dd>
                </div>
              </>
            ))}
          </dl>
        )}
      </div>
    </div>
  );
}
